import { render, staticRenderFns } from "./Inwords.vue?vue&type=template&id=787c626c"
import script from "./Inwords.vue?vue&type=script&lang=js"
export * from "./Inwords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports